// extracted by mini-css-extract-plugin
export var gallvid = "img_strip-module--gallvid--9a1f1";
export var image = "img_strip-module--image--e636c";
export var image_show = "img_strip-module--image_show--ffbb7";
export var img = "img_strip-module--img--ba43a";
export var menu = "img_strip-module--menu--6ee34";
export var menu_btn = "img_strip-module--menu_btn--2577e";
export var menu_wr = "img_strip-module--menu_wr--79da0";
export var pdpzoom = "img_strip-module--pdpzoom--a254e";
export var strip = "img_strip-module--strip--74d46";
export var strip_bar = "img_strip-module--strip_bar--cdbcc";
export var strip_menu = "img_strip-module--strip_menu--89a33";
export var vid_show = "img_strip-module--vid_show--b7de4";
export var videoJs = "img_strip-module--video-js--c67e1";
export var vjsPoster = "img_strip-module--vjs-poster--438af";
export var zoom = "img_strip-module--zoom--a0729";
export var zoom_btn = "img_strip-module--zoom_btn--b1ae0";
export var zoom_image = "img_strip-module--zoom_image--d1145";
export var zoom_img = "img_strip-module--zoom_img--e963e";
export var zoom_on = "img_strip-module--zoom_on--91910";